
        <select
            class="k-dropdown k-pager-nav"
            kendoGridFocusable
            tabindex="0"
            [value]="(currentPage).toString()"
            (change)="onSelectChange($event)">
            <option *ngIf="start > 1"
                class="k-link"
                value="previousButtons"
                [attr.aria-label]="pageLabel(start - 1)">...
            </option>
            <option *ngFor="let num of buttons"
                [value]="num.toString()"
                [attr.aria-label]="pageLabel(num)"
                [attr.aria-current]="currentPage == num ? 'page' : undefined"
                [ngClass]="{'k-link': true, 'k-state-selected':currentPage == num}">
                {{num}}
            </option>
            <option *ngIf="end < totalPages"
                value="nextButtons"
                class="k-link"
                [attr.aria-label]="pageLabel(end + 1)">...
            </option>
        </select>
        <ul [ngClass]="{'k-pager-numbers': true, 'k-reset': true}">
            <li *ngIf="start > 1">
                <span
                    kendoGridFocusable
                    tabindex="0"
                    class="k-link k-pager-nav"
                    [attr.aria-label]="pageLabel(start - 1)"
                    (click)="changePage(start - 2)"
                    (keydown.enter)="changePage(start - 2)">...</span>
            </li>
            <li *ngFor="let num of buttons">
                <span
                    kendoGridFocusable
                    tabindex="0"
                    [attr.aria-label]="pageLabel(num)"
                    [ngClass]="{'k-link': true, 'k-state-selected':currentPage == num, 'k-pager-nav': true}"
                    (click)="changePage(num - 1)"
                    (keydown.enter)="changePage(num - 1)">
                    {{num}}
                </span>
            </li>
            <li *ngIf="end < totalPages">
                <span
                    kendoGridFocusable
                    tabindex="0"
                    class="k-link k-pager-nav"
                    [attr.aria-label]="pageLabel(end + 1)"
                    (click)="changePage(end)"
                    (keydown.enter)="changePage(end)">...</span>
            </li>
        </ul>
    